/* ============================================================
   CELLSHE · Aging Well After 40 — guide page behaviour
   Upload to: Online Store > Themes > Edit code > Assets > aging-well.js
   Loaded by sections/page-aging-well.liquid via asset_url.
   Handles: optional email (Oct 2026: the guide is no longer gated) -> open the PDF
            in a new tab + auto-print, Klaviyo newsletter subscribe (background, only
            when an email is given), reading-progress bar.
   Lives in an asset file (not inline) so the theme's section renderer
   never re-parses the HTML strings inside it.
   ============================================================ */
(function () {
  if (window.__awaGuideBound) { return; }
  window.__awaGuideBound = true;

  var KLAVIYO_KEY  = "TUXWZB";
  var KLAVIYO_LIST = "SY393L";  /* Email List (general newsletter) — triggers the welcome flow. Source stays "Aging Well After 40 guide" for segmentation. */
  var PDF = "https://cdn.shopify.com/s/files/1/0999/2644/2361/files/CELLSHE-Aging-Well-After-40.pdf?v=1784815321";

  /* Open the PDF in the given (already-opened) window and pop the print dialog.
     We fetch the PDF as a same-origin blob (Shopify CDN sends Access-Control-Allow-Origin: *)
     and print the PDF document itself via the iframe's own contentWindow — printing the
     wrapper page instead would rasterise the PDF-viewer chrome onto one sheet ("inception"). */
  function openGuide(w) {
    if (!w) { window.location.href = PDF; return; }

    try {
      w.document.open();
      w.document.write('<!doctype html><html lang="en"><head><meta charset="utf-8">'
        + '<title>Aging Well After 40 — CELLSHE</title>'
        + '<style>html,body{margin:0;height:100%;background:#f1e8d5;font:15px/1.6 Inter,-apple-system,Arial,sans-serif;color:#3A1820}'
        + '.l{position:absolute;top:50%;left:0;right:0;transform:translateY(-50%);text-align:center;letter-spacing:.02em}</style>'
        + '</head><body><div class="l">Preparing your guide…</div></body></html>');
      w.document.close();
    } catch (e) {}

    fetch(PDF).then(function (r) { return r.blob(); }).then(function (b) {
      var url;
      try { url = (w.URL || window.URL).createObjectURL(b); }
      catch (e) { url = window.URL.createObjectURL(b); }
      try {
        w.document.open();
        w.document.write('<!doctype html><html lang="en"><head><meta charset="utf-8">'
          + '<title>Aging Well After 40 (PDF) — CELLSHE</title>'
          + '<style>html,body{margin:0;height:100%;background:#f1e8d5}iframe{border:0;width:100%;height:100vh;display:block}</style>'
          + '</head><body><iframe id="awpdf" src="' + url + '"></iframe></body></html>');
        w.document.close();
      } catch (e) { try { w.location.href = url; } catch (er) { w.location.href = PDF; } return; }

      var ifr = w.document.getElementById('awpdf');
      if (ifr) {
        ifr.addEventListener('load', function () {
          setTimeout(function () {
            try { ifr.contentWindow.focus(); ifr.contentWindow.print(); }
            catch (e) { try { w.print(); } catch (er) {} }
          }, 500);
        });
      }
    }).catch(function () {
      /* fetch failed — just show the PDF; the viewer's own print button prints it cleanly */
      try { w.location.href = PDF; } catch (e) { window.location.href = PDF; }
    });
  }

  /* Delegated on document so it keeps working through Horizon's section re-render / view transitions. */
  document.addEventListener('submit', function (e) {
    var form = (e.target && e.target.closest) ? e.target.closest('.js-awa-form') : null;
    if (!form) { return; }
    e.preventDefault();

    var msg   = form.querySelector('.js-awa-msg');
    var hp    = form.querySelector('.js-awa-hp');
    var email = form.querySelector('input[type=email]');
    var btn   = form.querySelector('button[type=submit]');

    var bot = !!(hp && hp.value);
    var v = email ? (email.value || '').trim() : '';

    /* Email is optional: an empty field opens the guide; only a mistyped address is stopped. */
    if (!bot && v && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(v)) {
      if (msg) { msg.textContent = 'Please check your email address, or leave it empty to open the guide.'; }
      if (email) { email.focus(); }
      return;
    }

    if (msg) { msg.textContent = 'Opening your guide in a new tab — read, save or print it from there.'; }
    if (btn) { btn.disabled = true; setTimeout(function () { btn.disabled = false; }, 1500); }

    /* Open + write the PDF immediately, inside the click gesture, so it is never popup-blocked. */
    var w = window.open('', '_blank');
    if (w) { try { w.opener = null; } catch (err) {} }
    openGuide(w);

    /* Subscribe to the Klaviyo list in the background (fire-and-forget). */
    if (!bot && v) {
      try {
        var payload = {
          data: {
            type: "subscription",
            attributes: {
              custom_source: "Aging Well After 40 guide",
              profile: { data: { type: "profile", attributes: { email: v } } }
            },
            relationships: { list: { data: { type: "list", id: KLAVIYO_LIST } } }
          }
        };
        fetch("https://a.klaviyo.com/client/subscriptions/?company_id=" + encodeURIComponent(KLAVIYO_KEY), {
          method: "POST",
          headers: { "Content-Type": "application/json", "revision": "2024-10-15" },
          body: JSON.stringify(payload)
        }).catch(function () {});
      } catch (err) {}
    }
  }, false);

  /* Optional-email wording on both guide forms (set here so only this file changes). */
  var OPTIONAL_FINE = 'The full guide opens in a new tab to save or print as a PDF. Add your email if you’d like occasional evidence-informed notes from CELLSHE. You can unsubscribe anytime.';
  function applyOptionalCopy() {
    var inputs = document.querySelectorAll('.js-awa-form input[type=email]');
    for (var i = 0; i < inputs.length; i++) {
      inputs[i].required = false;
      inputs[i].placeholder = 'Your email (optional)';
    }
    var fines = document.querySelectorAll('.awa-fine');
    for (var j = 0; j < fines.length; j++) {
      if (/^\s*By entering your email/.test(fines[j].textContent)) { fines[j].textContent = OPTIONAL_FINE; }
    }
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', applyOptionalCopy); }
  else { applyOptionalCopy(); }

  /* Reading-progress bar. */
  window.addEventListener('scroll', function () {
    var pb = document.querySelector('.awa-progress');
    if (!pb) { return; }
    var h = document.documentElement;
    var dd = h.scrollHeight - h.clientHeight;
    pb.style.width = (dd > 0 ? (h.scrollTop / dd * 100) : 0) + '%';
  }, { passive: true });
})();